import * as React from 'react';
import * as modules from '../modules.module.scss';

export const modulesData = [
  {
    bage: 'Модуль 1',
    title: 'Знакомство с\u00A0методикой и\u00A0первый опыт ее\u00A0применения в\u00A0учебе',
    description: (
      <>
        <p>
          С первых же уроков ребенок будет оттачивать навыки, которые помогут ему достичь успехов в будущей
          профессиональной карьере и жизни в целом. Но практическую пользу от технологий эффективного обучения он увидит
          уже здесь и сейчас. Лёгкость в усвоении учебного материала, высокая результативность и удовольствие от
          процесса укрепят его веру в себя, расширят горизонт мышления. Качество знаний и успеваемость возрастёт, а
          время, которое нужно будет тратить на учёбу в школе и вузе — сократится.
        </p>
        <p>
          Уже на первых занятиях ребёнок научится лучше фокусировать внимание, а также быстро и прочно запоминать
          отдельные виды учебной информации. Кроме общих упражнений на развитие памяти и внимания, в модуль входят
          материалы по русскому языку, биологии и географии.
        </p>
      </>
    ),
    result: (
      <ul className={modules.modules__resultList}>
        <li className={modules.modules__resultItem}>
          Навык высокой концентрации внимания (до 15 минут непрерывной работы)
        </li>
        <li className={modules.modules__resultItem}>Базовое развитие внимания, памяти и воображения</li>
        <li className={modules.modules__resultItem}>
          Навык запоминания бинарной (парной) информации, в том числе логически не связанной
        </li>
        <li className={modules.modules__resultItem}>
          Освоение школьного материала: ребёнок выучит названия стран и столиц, до автоматизма отработает сложные случаи
          ударения в русских словах, запомнит несколько архаизмов и список из аминокислот.
        </li>
      </ul>
    ),
  },

  {
    bage: 'Модуль 2',
    title: 'Сложные информационные объекты и\u00A0работа с\u00A0ними',
    description: (
      <p>
        Информация, с которой мы имеем дело в реальной жизни, чаще всего плохо структурирована и не адаптирована
        под лёгкое запоминание. Поэтому следующий этап курса — обеспечить ребёнку навыки работы с более сложной
        информацией. В курсе этот переход от простого к сложному реализован плавно, это позволит сохранить мотивацию
        к дальнейшему прохождению курса.
      </p>
    ),
    result: (
      <ul className={modules.modules__resultList}>
        <li className={modules.modules__resultItem}>Навык самостоятельно фокусировать внимание до 30 минут</li>
        <li className={modules.modules__resultItem}>Развитие внимания, памяти и воображения</li>
        <li className={modules.modules__resultItem}>
          Навык быстрого запоминания иностранных слов на примере разных языков
        </li>
        <li className={modules.modules__resultItem}>Навык запоминать последовательности и информационные цепочки</li>
        <li className={modules.modules__resultItem}>Применение метода лоций (метод Цицерона)</li>
        <li className={modules.modules__resultItem}>Навык запоминать цифровую информацию</li>
        <li className={modules.modules__resultItem}>
          Первый опыт работы со сложными разнородными таблицами, на примере запоминания Таблицы Менделеева
        </li>
        <li className={modules.modules__resultItem}>Навык поиска нужной информации в текстовом массиве</li>
        <li className={modules.modules__resultItem}>
          Освоение школьного материала: даты истории – смутное время, дополнительные аминокислоты, географические
          объекты, биологические возбудители, пары черепных нервов, витамины, латинские корни.
        </li>
      </ul>
    ),
  },

  {
    bage: 'Модуль 3',
    title: 'Заключительный модуль развития памяти и\u00A0переход к\u00A0развитию логического мышления',
    description: (
      <p>Третий модуль завершает формирование фундамента (базовых навыков) для всего дальнейшего обучения.</p>
    ),
    result: (
      <>
        <ul className={modules.modules__resultList}>
          <li className={modules.modules__resultItem}>Навык самостоятельно фокусировать внимание до 45 минут</li>
          <li className={modules.modules__resultItem}>
            Развитие внимания, памяти и воображения до профессионального уровня
          </li>
          <li className={modules.modules__resultItem}>Навык запоминания формул, таблиц, схем и карт</li>
          <li className={modules.modules__resultItem}>
            Работа со сложными информационными объектами: теоремы, доказательства, формулы, правила, определения.
          </li>
          <li className={modules.modules__resultItem}>
            Освоение школьного материала: лексика английского языка, основные неправильные глаголы, географические
            объекты, субъекты РФ и их административные центры, даты истории России VIII -XX вв., даты жизни правителей и
            писателей, формулы физики и математики, химия – алканы, основы зоологии и анатомии.
          </li>
        </ul>
        <div className={modules.modules__resultDescr}>
          <p>
            <b>По итогам первых трех модулей</b> ребенок освоит техники и методы, которые позволят быстро и прочно
            запоминать, а также качественно воспроизводить не только школьный материал, но и любую учебную или
            профессиональную информацию.
          </p>
          <p>
            На основе этого опыта ребёнок осознает, что его возможности намного шире, чем он мог себе представить. Он
            сможет самостоятельно управлять своим развитием, что укрепит его мотивацию и веру в себя.
          </p>
        </div>
      </>
    ),
  },

  {
    bage: 'Модуль 4',
    title: 'Технология работы с\u00A0информацией',
    description: (
      <p>
        Благодаря предыдущему этапу ребёнок, говоря образно, уже пересел с лошади на трактор — его интеллектуальные
        возможности перешли на новый уровень, а скорость обучения возросла. Настало время развить аналитические
        способности «водителя», чтобы в дальнейшем он мог управлять уже «скоростным автомобилем» своего интеллекта.
      </p>
    ),
    result: (
      <ul className={modules.modules__resultList}>
        <li className={modules.modules__resultItem}>Навык понимать причинно-следственные связи.</li>
        <li className={modules.modules__resultItem}>Навык работы с майнд-картами.</li>
        <li className={modules.modules__resultItem}>Навык работать с символами и символьной информацией.</li>
        <li className={modules.modules__resultItem}>Навык выбирать способ поиска информации.</li>
        <li className={modules.modules__resultItem}>Навык выбирать способ запоминания информации.</li>
        <li className={modules.modules__resultItem}>Умение классифицировать информацию по различным основаниям.</li>
        <li className={modules.modules__resultItem}>Умение применять теорию множеств для классифицирования.</li>
        <li className={modules.modules__resultItem}>
          Умение самостоятельно анализировать текст от одного до нескольких абзацев с сохранением главных тезисов в
          долговременную память.
        </li>
        <li className={modules.modules__resultItem}>Начало отработки навыков скорочтения.</li>
        <li className={modules.modules__resultItem}>Умение самостоятельно фокусировать внимание до 60 минут.</li>
        <li className={modules.modules__resultItem}>
          Освоение школьного материала: теоремы математики, грамматика и правила русского языка.
        </li>
      </ul>
    ),
  },

  {
    bage: 'Модуль 5',
    title: 'Термины, определения и\u00A0дефиниции',
    description: (
      <p>
        Профессионализм в любой области тесно связан с владением терминологией. В школьной программе изучается
        универсальный набор терминов. Каждая профессия расширяет эту базу, добавляя новые значения к старым. Поэтому мы
        посвятили отдельный модуль работе с терминами и определениями — ребёнок на школьном материале получит навык
        работы с терминологией. Применяя его к любой сфере, он сможет быстро осваивать любые специальности
        совершенствоваться профессионально.
      </p>
    ),
    result: (
      <ul className={modules.modules__resultList}>
        <li className={modules.modules__resultItem}>Ребёнок научится запоминать термины и определения</li>
        <li className={modules.modules__resultItem}>Освоит ранее неизвестные значения</li>
        <li className={modules.modules__resultItem}>
          Научится связывать новую информацию с уже имеющимися в памяти сведениями.
        </li>
        <li className={modules.modules__resultItem}>Поставит навык выделения главного в тексте</li>
        <li className={modules.modules__resultItem}>
          Освоит школьный материал: выучит определения истории, географии, обществознания.
        </li>
      </ul>
    ),
  },

  {
    bage: 'Модуль 6',
    title: 'Самостоятельно пройти учебник за\u00A0неделю? Легко!',
    description: (
      <p>
        Этот модуль поставит навык эффективной работы с большим объемом разнородной информации. Ребёнок сможет за один
        подход охватывать вниманием уже не абзац или параграф, а целый учебник. Он сделает это с помощью специальных
        алгоритмов под руководством наших педагогов. Для того, чтобы работать с такими объемами текста, необходимо
        владеть хорошей скоростью чтения — на развитие этого навыка в данном модуле будет сделан особый упор. Ребёнок
        освоит эффективное чтение и сможет прорабатывать печатную информацию на максимальной скорости (до 500 слов в
        минуту) с полным пониманием и сохранением главных мыслей в долгосрочную память.
      </p>
    ),
    result: (
      <ul className={modules.modules__resultList}>
        <li className={modules.modules__resultItem}>Навык быстрого самостоятельного прохождения целого учебника</li>
        <li className={modules.modules__resultItem}>Навыки скорочтения</li>
        <li className={modules.modules__resultItem}>Навыки постановки целей для работы с информацией</li>
        <li className={modules.modules__resultItem}>Навыки планирования образовательного процесса</li>
        <li className={modules.modules__resultItem}>
          Освоение школьного материала: прохождение целого учебника на примере физики за 8 и 9 классы.
        </li>
      </ul>
    ),
  },

  {
    bage: 'Модуль 7',
    title: 'Финишная прямая',
    description: (
      <>
        <p>
          С первых же уроков ребенок будет оттачивать навыки, которые помогут ему достичь успехов в будущей
          профессиональной карьере и жизни в целом. Но практическую пользу от технологий эффективного обучения он увидит
          уже здесь и сейчас. Лёгкость в усвоении учебного материала, высокая результативность и удовольствие от
          процесса укрепят его веру в себя, расширят горизонт мышления. Качество знаний и успеваемость возрастёт, а
          время, которое нужно будет тратить на учёбу в школе и вузе — сократится.
        </p>
        <p>
          Уже на первых занятиях ребёнок научится лучше фокусировать внимание, а также быстро и прочно запоминать
          отдельные виды учебной информации. Кроме общих упражнений на развитие памяти и внимания, в модуль входят
          материалы по русскому языку, биологии и географии.
        </p>
      </>
    ),
    result: (
      <>
        <ul className={modules.modules__resultList}>
          <li className={modules.modules__resultItem}>Навык быстро ориентироваться в информационном потоке</li>
          <li className={modules.modules__resultItem}>
            Навык легко обрабатывать любую информацию и сохранять ее в долговременной памяти.
          </li>
        </ul>
        <div className={modules.modules__resultDescr}>
          <p>
            <b>По итогам курса</b> ребенок освоит техники и методы, которые позволят быстро и прочно запоминать, а также
            качественно воспроизводить не только школьный материал, но и любую учебную или профессиональную информацию.
          </p>
          <p>Например, он сможет легко запомнить 500 новых слов за один день или 200 дат за 2-3 часа.</p>
          <p>
            На основе этого опыта ребёнок осознает, что его возможности намного шире, чем он мог себе представить. Он
            сможет самостоятельно управлять своим развитием, что укрепит его мотивацию и веру в себя.
          </p>
          <p>
            У ребёнка сформируется целостное мышление — любую информацию он научится воспринимать как часть общего. Это
            позволит ему видеть источник проблем и находить решения в самых разных областях знаний.
          </p>
          <p>
            Мы стремимся, чтобы каждый ученик научился управлять жизнью. Именно под эту задачу на наших курсах мы
            формируем портфель интеллектуальных навыков и компетенций.
          </p>
          <p>
            Ребёнок приобретёт уверенность в том, что любая цель может быть достигнута. Он научится раскладывать большие
            задачи на преодолимые этапы и самостоятельно выстраивать путь к цели. Более широкий горизонт мышления
            позволяет видеть вокруг себя скрытые возможности.
          </p>
          <p>15% наших выпускников переходят на экстернат или самостоятельно осваивают новые профессии.</p>
        </div>
      </>
    ),
  },
];
